import type { TopupAttentionRow, TopupRetryResult } from "@/interfaces/topups";
import { apiClient } from "@/lib/apiClient";

/**
 * The campaigns whose automatic funding needs a person, and the retry the strip offers.
 *
 * One endpoint for GFG staff and clients both — the server scopes the rows, so this never asks who
 * is looking.
 */

export async function fetchTopupsNeedingAttention(): Promise<TopupAttentionRow[]> {
  const { data } = await apiClient.get<{ data: TopupAttentionRow[] }>(
    "/campaigns/topups/attention",
  );
  return data.data ?? [];
}

export async function retryTopup(campaignId: number): Promise<TopupRetryResult> {
  const { data } = await apiClient.post<{ call: TopupRetryResult }>(
    `/campaigns/${campaignId}/topup`,
  );
  return data.call;
}
